import { render, staticRenderFns } from "./CreaTask.vue?vue&type=template&id=3a7f965a&scoped=true&slot=tag&slot-scope=props&"
import script from "./CreaTask.vue?vue&type=script&lang=js&"
export * from "./CreaTask.vue?vue&type=script&lang=js&"
import style0 from "./CreaTask.vue?vue&type=style&index=0&id=3a7f965a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7f965a",
  null
  
)

export default component.exports